import React from "react";
import { bannerElementsProps } from "../../features/createBanner/bannerTypes";
import BannerTemplateOptionConfigNew from "./BannerTemplateOptionConfigNew";

function BannerElementsNew(props: any) {
  // 
  return (
    <>
      {props.bannerElements.map((bannerElement:any, index:any) => {
        return (
          <BannerTemplateOptionConfigNew
            key={index}
            elemNumber={index}
            bannerResolutionType={props.bannerResolutionType}
            bannerBehaviour={props.bannerBehaviour}
            elementState={bannerElement}
            setLanguageBannerState={props.setLanguageBannerState}
            checkErrors={props.checkErrors}
            categories={props.categories}
            baskets={props.baskets}
            languageCode={props.languageCode}
            isEdit={props.isEdit}
          />
        );
      })}
    </>
  );
}

export default BannerElementsNew;
